import { useReveal } from "@/hooks/useReveal";

const ELYSEE_FRONT = "https://customer-assets.emergentagent.com/job_private-collection-12/artifacts/elysee_front.jpeg";
const ELYSEE_PROFILE = "https://customer-assets.emergentagent.com/job_private-collection-12/artifacts/elysee_profile.jpeg";

const SPECS = [
  { label: "Collection", value: "Heritage" },
  { label: "Movement", value: "Automatic Mechanical Open-Heart" },
  { label: "Case", value: "Rose Gold" },
  { label: "Dial", value: "Deep Blue Textured" },
  { label: "Crystal", value: "Sapphire" },
  { label: "Strap", value: "Hand-Stitched Blue Leather" },
];

export default function HeritageSection({ onRequest }) {
  const eyebrow = useReveal();
  const title = useReveal();
  const lead = useReveal();
  const imgR = useReveal();
  const detailR = useReveal();

  return (
    <section id="heritage" data-testid="heritage-section" className="relative bg-black py-28 md:py-40 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p ref={eyebrow} className="pd-reveal eyebrow" data-testid="heritage-eyebrow">Heritage Collection</p>
          <h2 ref={title} className="pd-reveal mt-6 font-serif-display text-4xl md:text-6xl lg:text-7xl text-white tracking-[0.06em]" style={{ transitionDelay: "160ms" }} data-testid="heritage-title">
            The Beginning <br />
            <span className="italic font-serif-body text-white/85">of the Maison.</span>
          </h2>
          <div ref={lead} className="pd-reveal mt-8" style={{ transitionDelay: "320ms" }}>
            <p className="font-light text-white/65 text-base md:text-lg leading-relaxed tracking-wide">
              Earlier chapters from the PiérrecDavís archive — quieter pieces that taught the maison its own hand.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div ref={imgR} className="pd-reveal lg:col-span-7 grid grid-cols-3 gap-4">
            <div className="col-span-2 aspect-[3/4] overflow-hidden border border-[var(--pd-border)] bg-[#0a0a0a]">
              <img src={ELYSEE_FRONT} alt="Élysée Open-Heart Automatic — front" className="w-full h-full object-contain transition-transform duration-[2000ms] hover:scale-105" data-testid="heritage-elysee-front" />
            </div>
            <div className="aspect-[3/4] overflow-hidden border border-[var(--pd-border)] bg-[#0a0a0a]">
              <img src={ELYSEE_PROFILE} alt="Élysée Open-Heart Automatic — profile" className="w-full h-full object-contain transition-transform duration-[2000ms] hover:scale-105" data-testid="heritage-elysee-profile" />
            </div>
          </div>

          <div ref={detailR} className="pd-reveal lg:col-span-5">
            <p className="eyebrow text-[var(--pd-gold)]">PiérrecDavís® · Heritage Reference</p>
            <h3 className="font-serif-display text-3xl md:text-5xl text-white tracking-[0.06em] mt-4" data-testid="heritage-elysee-name">
              Élysée <br /><span className="italic font-serif-body">Open-Heart Automatic</span>
            </h3>

            <p className="mt-6 text-white/70 leading-relaxed font-light">
              A refined expression of classical watchmaking — polished rose gold, a deep blue textured dial, and an open-heart aperture revealing the living rhythm of the automatic movement within.
            </p>
            <p className="mt-4 text-white/55 italic font-serif-body text-lg">
              The Élysée is not designed to follow trends. It is designed to endure.
            </p>

            <div className="mt-8 space-y-3">
              {SPECS.map((s) => (
                <div key={s.label} className="flex items-baseline justify-between gap-6 border-b border-white/10 pb-3" data-testid={`heritage-spec-${s.label.toLowerCase()}`}>
                  <span className="text-[0.65rem] uppercase tracking-[0.32em] text-white/50">{s.label}</span>
                  <span className="font-serif-body text-base text-white text-right">{s.value}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 flex items-baseline justify-between border-t border-[var(--pd-border)] pt-6">
              <span className="eyebrow">Price</span>
              <span className="font-serif-display text-2xl md:text-3xl text-[var(--pd-gold)] tracking-[0.1em]" data-testid="heritage-elysee-price">$26,000 USD</span>
            </div>

            <p className="mt-6 text-white/50 text-xs uppercase tracking-[0.32em]">
              Available exclusively through private appointment.
            </p>

            <button data-testid="heritage-elysee-cta" onClick={onRequest} className="btn-gold mt-8">
              <span>Request Private Appointment</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
